import { Component, OnDestroy } from '@angular/core';
import { GuardsCheckEnd, GuardsCheckStart, NavigationCancel, Router, ActivatedRoute, NavigationEnd, ActivationEnd } from '@angular/router';
import { SplashScreen } from '@capacitor/splash-screen';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnDestroy {

    loading = new BehaviorSubject<boolean>(true);
    hideLoad = false;
    hasRun = false;

    private subscription: Subscription = new Subscription();

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private authservice: AuthService) {
        this.initializeApp();

        this.subscription.add(
            authservice.loading.subscribe(x => { this.hideLoad = false; this.loading.next(x); })
        );

        this.subscription.add(
            this.router.events.subscribe(event => {
                if (this.hasRun === false) {
                    if (event instanceof GuardsCheckStart) {
                        this.loading.next(true);
                        this.hideLoad = false;
                        console.log('GuardStart');
                    }
                    else if (event instanceof GuardsCheckEnd || event instanceof NavigationCancel) {
                        setTimeout(() => {
                            this.hideLoad = true;
                            this.hasRun = true;
                            this.loading.next(false);
                            console.log('GuardEnd');
                        }, 3000);
                    }
                }

                if (event instanceof ActivationEnd) {
                    if (event.snapshot.data.title !== undefined) {
                        this.authservice.currentApplication.next(event.snapshot.data);
                    }
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    initializeApp() {
        SplashScreen.hide();
    }
}
